export default __webpack_public_path__ + "static/media/faq-desktop@2x.d60403e2.webp";